import React, { useMemo } from 'react'
import { Button, LinkInline } from '@dasa-health/alma-react'
import { Typography } from '@dasa-health/components-react'
import { GenericCollapse } from '../GenericCollapse'
import { ButtonBox, CollapseContainer, Container } from './styles'
import { useAppContext } from '@nsw-paginas-deslogadas/store'

interface FoldFaqProductProps {
    examLink?: string
    vaccineActive?: boolean
    vaccineLink?: string
}

const FoldFaqProduct: React.FC<FoldFaqProductProps> = ({ vaccineLink, examLink, vaccineActive = false }) => {
    const { product, prepare, brand } = useAppContext()
    const scheduleInfo = prepare.find(prod => prod.prepareType.apiCode === 'necessita_agendamento')
    const fastingInfo = prepare.find(prod => prod.prepareType.apiCode === 'informacao_jejum')
    const guidanceInfo = prepare.find(prod => prod.prepareType.apiCode === 'orientacao_geral')
    const formattedCities = brand.cities.join(', ').toLowerCase()

    const questions = [
        {
            title: 'Também conhecido como:',
        },
        {
            title: 'Formas de Pagamento',
        },
        {
            title: `Preparo ${product.category?.id === 4 ? 'da vacina' : ' do exame'}`,
        },
        {
            title: 'Onde é realizado',
        },
        {
            title: 'Orientações Gerais',
        },
    ]

    const productLabel = useMemo(() => `Agendar ${product.category?.id === 4 ? 'vacina' : 'exame'}`, [product])

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'FAQ',
        'data-current-service': 'Página de Produto da Marca',
        'data-item-text': dataText,
    })

    return (
        <Container data-testid="faq-testID">
            <Typography as="h2" className="frequentFaq">
                Dúvidas frequentes
            </Typography>
            <CollapseContainer>
                <GenericCollapse isOpen={false} showDivider title={questions[0].title}>
                    <Typography as="h3">{product.synonymies?.join(', ')}</Typography>
                </GenericCollapse>

                <GenericCollapse isOpen={false} showDivider title={questions[1].title}>
                    <Typography as="h3">
                        As unidades de {brand.name} aceitam Dinheiro, Cheque e Cartão de crédito dividindo em até 12x sem juros.
                    </Typography>
                </GenericCollapse>

                <GenericCollapse className="multi-text-container" isOpen={false} showDivider title={questions[2].title}>
                    {scheduleInfo && (
                        <Typography as="h3" className="multi-text">
                            Informações do Agendamento
                            <Typography as="h3">{scheduleInfo?.description}</Typography>
                        </Typography>
                    )}

                    <Typography as="h3" className="multi-text">
                        Informações de Jejum
                        <Typography as="h3">
                            {fastingInfo
                                ? fastingInfo.description
                                : `${product.category?.id === 4 ? 'Esta vacina' : 'Este exame'} não necessita de jejum`}
                        </Typography>
                    </Typography>

                    {guidanceInfo && (
                        <Typography as="h3" className="multi-text">
                            Orientações Gerais
                            <Typography as="h3">{guidanceInfo?.description}</Typography>
                        </Typography>
                    )}
                </GenericCollapse>

                <GenericCollapse isOpen={false} showDivider title={questions[3].title}>
                    <Typography as="h3">
                        {brand.name} tem várias unidades {brand.cities.length > 1 ? 'nas cidades de ' : 'na cidade de '}
                        <Typography className="cities">{formattedCities}</Typography>. Clique no botão “agendar”, faça seu login,
                        escolha os exames/vacinas que deseja agendar e eu vou lhe mostrar as unidades mais perto de você!
                    </Typography>
                </GenericCollapse>

                {guidanceInfo && (
                    <GenericCollapse isOpen={false} showDivider title={questions[4].title}>
                        <Typography as="h3">{guidanceInfo?.description}</Typography>
                    </GenericCollapse>
                )}
            </CollapseContainer>
            <ButtonBox>
                {product?.category && (
                    <LinkInline
                        href={product.navigateTo}
                        sx={{ textDecoration: 'none' }}
                        target="_self"
                        {...dataAtributtes(productLabel)}
                    >
                        <Button data-testid="btn-exams">{productLabel}</Button>
                    </LinkInline>
                )}

                {!product?.category && (
                    <>
                        {vaccineActive && (
                            <LinkInline
                                href={vaccineLink}
                                sx={{ textDecoration: 'none' }}
                                target="_self"
                                {...dataAtributtes('Agendar vacina')}
                            >
                                <Button fullWidth variant="primary">
                                    Agendar vacina
                                </Button>
                            </LinkInline>
                        )}

                        <a href={examLink} target="_self" {...dataAtributtes('Agendar exame')}>
                            <Button fullWidth variant="primary">
                                Agendar exame
                            </Button>
                        </a>
                    </>
                )}
            </ButtonBox>
        </Container>
    )
}

export default FoldFaqProduct
